module.exports = __webpack_public_path__ + "img/art2.8a1a01ec.png";